import Metadata from "../metadata.js";
function getPossibleCountriesForNumber(callingCode, nationalNumber, metadata) {
  var _metadata = new Metadata(metadata), possibleCountries = _metadata.getCountryCodesForCallingCode(callingCode);
  return possibleCountries ? possibleCountries.filter(function(country) {
    return couldNationalNumberBelongToCountry(nationalNumber, country, metadata);
  }) : [];
}
function couldNationalNumberBelongToCountry(nationalNumber, country, metadata) {
  var _metadata = new Metadata(metadata);
  return _metadata.selectNumberingPlan(country), _metadata.numberingPlan.possibleLengths().indexOf(nationalNumber.length) >= 0;
}
export {
  getPossibleCountriesForNumber as default
};
//# sourceMappingURL=getPossibleCountriesForNumber.js.map
